import axios from 'axios';
// Importamos la función getAccessToken de nuestro módulo de Keycloak
import { getAccessToken } from '../services/api/keycloak';
import { setupResponseInterceptor } from './authInterceptor';

import qs from 'qs';

// Definimos la URL base de la API desde las variables de entorno
const API_BASE_URL = process.env.VUE_APP_ACARA_WEB_BACKEND_URL
  || process.env.VUE_APP_KEYCLOAK_API_BASE_URL
  || 'http://127.0.0.1:8001/api/v1';

// Creamos una instancia dedicada de Axios para la API
const instance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Cache-Control': 'no-cache',
  },
 paramsSerializer: (params) => {
    return qs.stringify(params, { 
      arrayFormat: 'brackets', // Genera filters[campo][]=valor (Estándar Laravel)
      encode: true 
    });
  }
});

// 🔄 Interceptor de REQUEST: agrega el Bearer token de Keycloak
instance.interceptors.request.use(
  async (config) => {
    try {
      // getAccessToken() debería encargarse de hacer updateToken() internamente
      const token = await getAccessToken();

      config.headers = config.headers || {};

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        // Si por alguna razón no hay token, nos aseguramos de no mandar uno viejo
        delete config.headers.Authorization;
      }

      return config;
    } catch (error) {
      console.error('Error al obtener o refrescar el token de Keycloak:', error);
      return Promise.reject(error);
    }
  },
  (error) => Promise.reject(error),
);

// Interceptor de RESPUESTA (lo configuramos en otro archivo)
setupResponseInterceptor(instance);


export default instance;